import { getAuthenticatedRequest } from './getAuthenticatedRequest.js';
import { getPublicRequest } from './getPublicRequest.js';
export async function getContextualRequest(client) {
    try {
        return await getAuthenticatedRequest(client);
    }
    catch (err) {
        return await getPublicRequest(client);
    }
}
